import api from '@/utils/api';
import {
    GET_TELESALE_FOLLOW_UPS,
    GET_TELESALE_FOLLOW_UP,
    ASSIGN_TELESALE_FOLLOW_UP,
    UPDATE_TELESALE_FOLLOW_UP,
    REMOVE_TELESALE_FOLLOW_UP,
    GET_TELESALE_FOLLOW_UPS_BY_CUSTOMER
} from './types';
import { NotificationManager } from 'react-notifications';

/**
 * Danh sách telesale follow ups
 */
export const getTelesaleFollowUps = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        api.get('/telesale-follow-ups', { params: filter })
            .then(res => {
                dispatch({
                    type: GET_TELESALE_FOLLOW_UPS,
                    payload: res.data.data
                });
                resolve(res.data);
            })
            .catch(err => {
                console.log(err);
                NotificationManager.error(err.response?.data?.msg);
                reject(err);
            });
    });
};

/**
 * Danh sách telesale follow ups theo customer
 */
export const getTelesaleFollowUpsByCustomer = (customer_id) => dispatch => {
    return new Promise((resolve, reject) => {
        api.get(`/telesale-follow-ups/customer/${customer_id}`)
            .then(res => {
                dispatch({
                    type: GET_TELESALE_FOLLOW_UPS_BY_CUSTOMER,
                    payload: res.data.data
                });
                resolve(res.data.data);
            })
            .catch(err => {
                console.log(err);
                NotificationManager.error(err.response?.data?.msg || 'Không tải được dữ liệu!');
                reject(err);
            });
    });
};

/**
 * Chi tiết 1 telesale follow up
 */
export const getTelesaleFollowUp = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        api.get(`/telesale-follow-ups/${id}`)
            .then(res => {
                dispatch({
                    type: GET_TELESALE_FOLLOW_UP,
                    payload: res.data.data
                });
                resolve(res.data.data);
            })
            .catch(err => {
                NotificationManager.error(err.response?.data?.msg);
                reject(err);
            });
    });
};


/**
 * Giao khách hàng cho nhân viên telesale (tạo bản ghi telesale follow up)
 */
export const assignTelesaleFollowUp = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        api.post('/telesale-follow-ups/assign', data)
            .then(res => {
                dispatch({
                    type: ASSIGN_TELESALE_FOLLOW_UP,
                    payload: res.data.data
                });
                NotificationManager.success('Đã giao khách hàng cho nhân viên!');
                resolve(res.data);
            })
            .catch(err => {
                NotificationManager.error(err.response?.data?.msg);
                reject(err);
            });
    });
};

/**
 * Update telesale follow up
 */
export const updateTelesaleFollowUp = (id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        api.put(`/telesale-follow-ups/update/${id}`, data)
            .then(res => {
                dispatch({
                    type: UPDATE_TELESALE_FOLLOW_UP,
                    payload: res.data.data
                });
                NotificationManager.success('Cập nhật bản ghi thành công!');
                resolve(res.data);
            })
            .catch(err => {
                NotificationManager.error(err.response?.data?.msg);
                reject(err);
            });
    });
};

/**
 * Trả kết quả telesale (được phân công)
 */
export const assignedTelesaleResult = (id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        api.put(`/telesale-follow-ups/assigned-result/${id}`, data)
            .then(res => {
                dispatch({
                    type: UPDATE_TELESALE_FOLLOW_UP,
                    payload: res.data.data
                });
                NotificationManager.success('Đã lưu kết quả telesale!');
                resolve(res.data);
            })
            .catch(err => {
                NotificationManager.error(err.response?.data?.msg);
                reject(err);
            });
    });
};

/**
 * Trả kết quả telesale (chủ động, chưa được phân công)
 */
export const manualTelesaleResult = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        api.post('/telesale-follow-ups/manual-result', data)
            .then(res => {
                dispatch({
                    type: UPDATE_TELESALE_FOLLOW_UP,
                    payload: res.data.data
                });
                NotificationManager.success('Đã lưu kết quả telesale!');
                resolve(res.data);
            })
            .catch(err => {
                NotificationManager.error(err.response?.data?.msg);
                reject(err);
            });
    });
};


/**
 * Xoá telesale follow ups
 */
export const removeTelesaleFollowUps = (ids) => dispatch => {
    return new Promise((resolve, reject) => {
        api.delete('/telesale-follow-ups', { data: { ids } })
            .then(res => {
                dispatch({
                    type: REMOVE_TELESALE_FOLLOW_UP,
                    payload: ids
                });
                NotificationManager.success('Xoá bản ghi thành công!');
                resolve(res.data);
            })
            .catch(err => {
                console.log(err);
                NotificationManager.error(err.response?.data?.msg);
                reject(err);
            });
    });
};

/**
 * Nhân viên tiếp nhận telesale (chỉ áp dụng cho mode = assigned)
 */
export const acceptTelesale = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        api.post(`/telesale-follow-ups/${id}/accept`)
            .then(res => {
                dispatch({
                    type: UPDATE_TELESALE_FOLLOW_UP,
                    payload: res.data.data
                });

                NotificationManager.success('Đã tiếp nhận telesale');
                resolve(res.data);
            })
            .catch(err => {
                NotificationManager.error(
                    err.response?.data?.msg || 'Không thể tiếp nhận telesale'
                );
                reject(err);
            });
    });
};


/**
 * Nhân viên hủy tiếp nhận telesale
 */
export const unacceptTelesale = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        api.post(`/telesale-follow-ups/${id}/unaccept`)
            .then(res => {
                dispatch({
                    type: UPDATE_TELESALE_FOLLOW_UP,
                    payload: res.data.data
                });

                NotificationManager.success('Đã hủy tiếp nhận telesale');
                resolve(res.data);
            })
            .catch(err => {
                NotificationManager.error(
                    err.response?.data?.msg || 'Không thể hủy tiếp nhận telesale'
                );
                reject(err);
            });
    });
};
